var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 428 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #757575;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.5,149.7c.3-15.6,70.2-13.4,63.5-24-10.8,1.4,136.8-16,119.2,37-3.2,32.9-2.9,52.5-4.9,68.7-2,16.2-32.8,15.8-64.2,26.8-11.4,6.4-36.3,14.9-64.9,12.6,21.4-4.5,22.2-8.5,17.3-39-4.5-32.5-5.8-53.6-26.8-72.7-13.9-15.2-39.3-9.5-39.3-9.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.1,122.3c-14,9.5,58.2,7.9,57.8,20.2-10.8,1.4-39.1-2.8-56.7,50.1-3,6.8-5.7,42.1-7.7,58.3-2,16.2-69.6-7.2-40.1-4.2s-122.1-24.3-89.3-32.1c21.4-4.5,13.8-9.6,9-40-4.5-32.5,33.2-28.4,40.7-36.6-13.9-15.2,86.3-15.7,86.3-15.7h0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Player_Right"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M344.5,134.5c-14.6-.4-29.5-.8-35.5,0-8.2,1.1-36.2,7.5-43.1,38.9-2.4,25-4.4,32-5.9,44.3s14.7,13.6,37.1,15.8,65,2.9,89.9-3c16.2-3.5,16.9-6.5,13.2-29.6-3.4-24.7-4.4-40.7-20.4-55.2-10.6-11.6-35.4-11.2-35.4-11.2h0Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 330.6,
    cy: 75.8,
    rx: 41.3,
    ry: 46.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Player_Left"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.5,134.5c-14.6-.4-29.5-.8-35.5,0-8.2,1.1-36.2,7.5-43.1,38.9-2.4,25-4.4,32-5.9,44.3s14.7,13.6,37.1,15.8,65,2.9,89.9-3c16.2-3.5,16.9-6.5,13.2-29.6-3.4-24.7-4.4-40.7-20.4-55.2-10.6-11.6-35.4-11.2-35.4-11.2h0Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 94.6,
    cy: 75.8,
    rx: 41.3,
    ry: 46.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Player_Center"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.2,158.8c-14.6-.4-29.5-.8-35.5,0-8.2,1.1-36.2,7.5-43.1,38.8-2.4,25-4.4,32-5.9,44.3-1.5,12.3,14.7,13.6,37.1,15.8s65,2.9,89.9-3c16.2-3.5,16.9-6.5,13.2-29.6-3.4-24.7-4.4-40.7-20.4-55.2-10.6-11.6-35.4-11.2-35.4-11.2h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 212.4,
    cy: 100.1,
    rx: 41.3,
    ry: 46.6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGames);
export default __webpack_public_path__ + "static/media/games.c3f3572f6dd04bdbcb62a4123f46a7cd.svg";
export { ForwardRef as ReactComponent };